import { normalizeRoleKey } from '@/domain/entities/role';
import { Permissions } from './permissions';

export const FixedOrgRoleKey = {
  Owner: 'owner',
  Viewer: 'viewer',
} as const;

export const FIXED_ORG_ROLE_KEYS = [FixedOrgRoleKey.Owner, FixedOrgRoleKey.Viewer] as const;

const VIEWER_CAPABILITY_PERMISSIONS = [
  Permissions.PropertiesRead,
  Permissions.ProjectsRead,
  Permissions.LocationsRead,
  Permissions.SystemsRead,
  Permissions.UtilitiesRead,
  Permissions.ItemsRead,
  Permissions.TemplatesRead,
  Permissions.DocumentsRead,
];

function toUnique(list: string[]) {
  return Array.from(new Set(list));
}

export function getFixedOrgRoleLabel(roleKey: string | null | undefined): string {
  const normalizedRoleKey = normalizeRoleKey(roleKey);
  if (normalizedRoleKey === FixedOrgRoleKey.Owner) return 'Owner';
  if (normalizedRoleKey === FixedOrgRoleKey.Viewer) return 'Viewer';
  return normalizedRoleKey || 'Fixed Role';
}

export function isFixedOrgRoleKey(roleKey?: string | null): boolean {
  const normalizedRoleKey = normalizeRoleKey(roleKey);
  return normalizedRoleKey === FixedOrgRoleKey.Owner || normalizedRoleKey === FixedOrgRoleKey.Viewer;
}

export function getFixedOrgRoleAccess(
  roleKey: string | null | undefined,
  orgCapabilities: string[],
): { roleName: string; permissions: string[] } | null {
  const normalizedRoleKey = normalizeRoleKey(roleKey);

  if (normalizedRoleKey === FixedOrgRoleKey.Owner) {
    return {
      roleName: FixedOrgRoleKey.Owner,
      permissions: toUnique([Permissions.MyOrgRead, Permissions.MyOrgUpdate, ...orgCapabilities]),
    };
  }

  if (normalizedRoleKey === FixedOrgRoleKey.Viewer) {
    const orgCapabilitiesSet = new Set(orgCapabilities);
    const enabledReadPermissions = VIEWER_CAPABILITY_PERMISSIONS.filter((permission) =>
      orgCapabilitiesSet.has(permission),
    );
    return {
      roleName: FixedOrgRoleKey.Viewer,
      permissions: toUnique([Permissions.MyOrgRead, Permissions.MemberRead, ...enabledReadPermissions]),
    };
  }

  return null;
}
